export default {
      id: "chevron-carousel-left-usage",
      viewBox: "0 0 8 15",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#chevron-carousel-left",
      toString: function () {
        return this.url;
      }
    }